// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let containerTestRuleEnum = {
    'None': 0,
    'AmericanFoulbrood': 1,
    'EuropeanFoulbrood': 2,
    'Varroa': 3,
    'HoneyCulture': 4
};

export default containerTestRuleEnum;
